export enum OrchestratorAuthType {
  TECHNICAL_USER = "TECHNICAL_USER",
  API_KEY = "API_KEY",
  CONFIDENTIAL_CLIENT = "CONFIDENTIAL_CLIENT"
}

interface OrchestratorConfig {
  host: string | null;
  tenancyName: string | null;
  orchestratorConnectionSuccess: boolean | null;
  authType: OrchestratorAuthType;
}

interface CloudOrchestratorConfig extends OrchestratorConfig {
  clientId: string | null;
  accountLogicalName: string | null;
}

export interface TechnicalUserOrchestratorConfig extends CloudOrchestratorConfig{
  technicalUserName: string | null;
  password: string | null;
  authType: OrchestratorAuthType.TECHNICAL_USER;
}

export interface ApiKeyOrchestratorConfig extends CloudOrchestratorConfig{
  authType: OrchestratorAuthType.API_KEY;
  apiKey: string | null;
}

export interface ConfidentialClientOrchestratorConfig extends OrchestratorConfig {
  authType: OrchestratorAuthType.CONFIDENTIAL_CLIENT;
  clientSecret: string | null;
}

export interface IOrganization {
  id: string;
  name: string;
  members: string[];
  isOrchestratorAvailable: boolean;
  orchestratorConfig?: TechnicalUserOrchestratorConfig | ApiKeyOrchestratorConfig | ConfidentialClientOrchestratorConfig;
}
